import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';

import { AccountClientDetailsService } from '../../service/account-client-edit/account-client-details.service';

@Component({
  template: '',
	selector: 'app-account-client-bycode',
	providers: [
		AccountClientDetailsService,
		HttpModule
	],
	moduleId: module.id
})

export class AccountClientByCodeComponent implements OnInit {

  private clientID: string = "";
  private clientCode: string = "";
  private token: string = "";
  private sub: any;

  constructor(private accountClientDetailsService: AccountClientDetailsService, private router: Router, private route: ActivatedRoute) {
    this.token = localStorage.getItem('yara.token');
  }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
			this.clientCode = params['codigo'];
		});

    this.accountClientDetailsService.getAccountClientIdByCode(this.token, this.clientCode).subscribe(result => {

      if (result.Result) {
        this.clientID = result.Result;
        this.router.navigateByUrl('/conta-cliente/detalhe/'+this.clientID);
      }

    });

  }

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-bycode/account-client-bycode.component.ts